import { Segment, Type } from './../../enums';
export const getTypeSegments = (type) => ({
    [Type.SECONDS]: [Segment.seconds],
    [Type.MINUTES]: [Segment.minutes],
    [Type.HOURS]: [Segment.hours],
    [Type.MONTH]: [Segment.month],
    [Type.YEAR]: [Segment.year],
    [Type.DAY]: [Segment.dayOfMonth, Segment.dayOfWeek]
})[type];
